import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { useAlertContext } from "../hooks";

export const AlertComponent = () => {
  const { alert, setAlert } = useAlertContext();
  const dialogStyle = alert?.sx ?? {};

  const handleCloseDialog = () => {
    setAlert((draft) => {
      draft.open = false;
    });
  };

  return (
    <Dialog
      open={alert.open}
      keepMounted
      aria-describedby="alert-dialog-slide-description"
      maxWidth="xl"
    >
      <Stack
        sx={{ width: { xs: "290px", md: 424 }, padding: "8px", ...dialogStyle }}
      >
        <DialogTitle sx={{ px: "16px", pb: 0 }}>
          {alert?.title === "string" ? (
            <Typography
              sx={{ fontWeight: 600, fontSize: 16, lineHeight: "19.36px" }}
            >
              {alert?.title}
            </Typography>
          ) : (
            alert?.title
          )}
        </DialogTitle>
        <DialogContent>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: 16,
              lineHeight: "19.36px",
            }}
          >
            {alert?.description}
          </Typography>
        </DialogContent>
        <DialogActions>
          {alert?.rowAction && alert.rowAction !== null ? (
            alert.rowAction
          ) : (
            <Button variant="outlined" size="small" onClick={handleCloseDialog}>
              Close
            </Button>
          )}
        </DialogActions>
      </Stack>
    </Dialog>
  );
};
